export type MetadataVocabKind = "title" | "speaker" | "tag" | "album_art";

export interface MetadataVocabLists {
  titles: string[];
  speakers: string[];
  tags: string[];
  albumArt: string[];
}

export function metadataVocabFromJson(json: Record<string, unknown>): MetadataVocabLists {
  return {
    titles: parseStringList(json.titles),
    speakers: parseStringList(json.speakers),
    tags: parseStringList(json.tags),
    albumArt: parseStringList(json.albumArt),
  };
}

function parseStringList(value: unknown): string[] {
  if (!Array.isArray(value)) return [];
  return value.filter((item): item is string => typeof item === "string");
}
